import React from 'react'

const AppDev = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="59"
      viewBox="0 0 59 59"
    >
      <g>
        <g>
          <path
            fill="#456afa"
            d="M0 5a5 5 0 0 1 5-5h49a5 5 0 0 1 5 5v49a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"
          />
        </g>
        <g>
          <g>
            <path
              fill="#fff"
              d="M34.505 32.98h-2l.194-1.52h2.193zm-.885 3.044h-1.502l.194-1.522h1.798c-.304.453-.474.98-.49 1.522zM30.93 32.98H28.43l-.193-1.522h2.889zm-.37 3.043H28.82l-.195-1.522h2.133zm-4.93 0l-.386-1.522h1.805l.193 1.522zm-.775-3.043l-.387-1.522h2.193l.193 1.522zm11.783 1.722c.391.006.763.17 1.027.453l7.754 8.231 1.14-1.033-5.248-5.57h.019v-20.54c-.003-2.1-1.74-3.802-3.882-3.804h-3.106v1.522h3.106c1.286 0 2.329 1.021 2.329 2.282v.76h-5.435v1.522h5.435v16.63l-.972-1.034a2.99 2.99 0 0 0-2.134-.94 2.935 2.935 0 0 0-.616.04l.597-2.34.626-2.466h.946v-1.521h-1.553a.774.774 0 0 0-.753.576l-.628 2.467H23.474a.769.769 0 0 0-.776.76c0 .063.008.124.023.185l1.553 6.086a.774.774 0 0 0 .753.576h8.98c.103.184.226.356.367.513l.608.671a.78.78 0 0 1-.639.338H24.251v1.521h10.092a2.352 2.352 0 0 0 1.68-.712l2.886 3.182a7.603 7.603 0 0 0 .747 5.846 2.318 2.318 0 0 1-2.207 1.574H21.922c-1.287 0-2.33-1.021-2.33-2.282v-.76H37.45v-1.522H19.593V24.612H18.04v23.584c.003 2.1 1.739 3.802 3.882 3.804h15.527c1.293 0 2.5-.63 3.222-1.682.257.28.534.54.83.782l.885.724.994-1.17-.885-.723c-2.039-1.652-2.826-4.364-1.98-6.82a.75.75 0 0 0-.156-.745l-4.823-5.318a1.39 1.39 0 0 1 .057-1.933 1.538 1.538 0 0 1 1.046-.412z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M26.32 44.64a1.84 1.84 0 1 0 0-3.68 1.84 1.84 0 0 0 0 3.68z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M34.6 44.64a1.84 1.84 0 1 0 0-3.68 1.84 1.84 0 0 0 0 3.68z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M32.11 19.54c0 .831-.702 1.505-1.569 1.505H10.14c-.867 0-1.57-.674-1.57-1.505V9.01c0-.831.703-1.505 1.57-1.505H30.54c.867 0 1.57.674 1.57 1.505zM30.542 6H10.14C8.405 6 7 7.348 7 9.01v10.54c0 1.662 1.405 3.01 3.139 3.01H30.54c1.734 0 3.139-1.348 3.139-3.01V9.01c0-1.662-1.405-3.01-3.139-3.01z"
            />
          </g>
          <g>
            <path fill="#fff" d="M9.76 9.68h13.8v.92H9.76z" />
          </g>
          <g>
            <path
              fill="#fff"
              d="M28.461 18.276a.854.854 0 0 1-.146-.02 2.013 2.013 0 0 0 0-1.503.906.906 0 0 1 .146-.02c.456 0 .825.345.825.771 0 .427-.37.772-.825.772zm-2.446 0c-.454 0-.822-.345-.822-.772 0-.426.368-.771.822-.771.453 0 .821.345.821.771 0 .427-.368.772-.821.772zm3.697-2.758a2.588 2.588 0 0 0-2.484 0 2.538 2.538 0 0 0-1.218-.318c-1.353 0-2.45 1.03-2.45 2.3 0 1.27 1.097 2.299 2.45 2.299.429-.002.85-.112 1.218-.317 1.166.644 2.668.279 3.354-.816.685-1.095.296-2.504-.87-3.148z"
            />
          </g>
          <g>
            <path fill="#fff" d="M10.68 15.2h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M13.44 15.2h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M17.12 15.2h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M19.88 15.2h.92v.92h-.92z" />
          </g>
          <g>
            <path fill="#fff" d="M10.68 17.04h11.04v.92H10.68z" />
          </g>
          <g>
            <path
              fill="#fff"
              d="M50.621 35.954L44.041 29l-1.161 1.006 6.584 6.96a3.651 3.651 0 0 1 1.05 2.554V52h1.566V39.52a5.099 5.099 0 0 0-1.459-3.566z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M31.898 25.26l-1.122.708V24.4h-1.552v1.568l-1.122-.708-.862 1.224 2.33 1.472c.26.165.6.165.86 0l2.33-1.472z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default AppDev
